module.exports = __webpack_public_path__ + "static/media/common-misconceptions-about-payment.7a549269.md";